// Order helpers — order ID generation + localStorage persistence.
// Actual email delivery requires a Resend/SendGrid integration (not enabled yet).

const RECENT_ORDERS_KEY = 'posterly_recent_orders_v1';
const MAX_RECENT_ORDERS = 20;

// e.g. PST-K7Q4L3 — short, human-friendly, unique enough for a WhatsApp-first flow
export const generateOrderId = () => {
  const rand = Math.random().toString(36).slice(2, 6).toUpperCase();
  const stamp = Date.now().toString(36).slice(-3).toUpperCase();
  return `PST-${stamp}${rand}`;
};

export const buildOrderRecord = ({ items, freeRewards, paidTotal, deliveryCharge = 0, unlockedTierIds, email }) => ({
  id: generateOrderId(),
  createdAt: new Date().toISOString(),
  email: email && email.trim() ? email.trim() : null,
  items: items.map((it) => ({
    productId: it.productId,
    name: it.name,
    category: it.category,
    sizeLabel: it.sizeLabel,
    quantity: it.quantity,
    unitPrice: it.unitPrice,
    lineTotal: it.unitPrice * it.quantity,
    image_url: it.image_url,
  })),
  freeRewards: Object.entries(freeRewards).map(([tierId, r]) => ({
    tierId,
    productId: r.productId,
    name: r.name,
    sizeLabel: r.sizeLabel,
    image_url: r.image_url,
  })),
  perks: {
    freeShipping: unlockedTierIds.includes('free_shipping'),
  },
  paidTotal,
  deliveryCharge,
  grandTotal: paidTotal + deliveryCharge,
});

export const saveOrderToHistory = (order) => {
  try {
    const raw = window.localStorage.getItem(RECENT_ORDERS_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const next = [order, ...(Array.isArray(list) ? list : [])].slice(0, MAX_RECENT_ORDERS);
    window.localStorage.setItem(RECENT_ORDERS_KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }
};

export const formatOrderAsText = (order) => {
  const lines = [];
  lines.push(`Posterly order ${order.id}`);
  lines.push(new Date(order.createdAt).toLocaleString());
  if (order.email) lines.push(`Email: ${order.email}`);
  lines.push('');
  order.items.forEach((it, i) => {
    lines.push(`${i + 1}. ${it.name}`);
    lines.push(`   ${it.category} · Size ${it.sizeLabel}`);
    lines.push(`   ₹${it.unitPrice} × ${it.quantity} = ₹${it.lineTotal}`);
    if (it.productId) lines.push(`   Link: ${window.location.origin}/product/${it.productId}`);
  });
  if (order.freeRewards.length > 0) {
    lines.push('');
    lines.push('FREE:');
    order.freeRewards.forEach((r, i) => {
      lines.push(`  ${i + 1}. ${r.name} (Size ${r.sizeLabel})`);
    });
  }
  lines.push('');
  lines.push(`Subtotal: ₹${order.paidTotal}`);
  lines.push(`Delivery: ${order.deliveryCharge > 0 ? `₹${order.deliveryCharge}` : 'FREE'}`);
  lines.push(`Total: ₹${order.paidTotal + (order.deliveryCharge || 0)}`);
  return lines.join('\n');
};
